module.exports = __webpack_public_path__ + "assets/img/zhengmiduyi.206f0d78.jpg";